export default "__VITE_ASSET__7de77093__"